import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["description", "button", "loader"];
  static values = { maxLength: Number, originalText: String };

  connect() {
    this.isTruncated = true;
    this.loaderTarget.classList.add("hidden");
    this.descriptionTarget.classList.remove("hidden");
    this.truncate();
  }

  toggle() {
    if (this.isTruncated) {
      this.descriptionTarget.innerHTML = this.originalTextValue;
      this.buttonTarget.textContent = "Read Less";
    } else {
      this.truncate();
      this.buttonTarget.textContent = "Read More";
    }
    this.isTruncated = !this.isTruncated;
  }

  truncate() {
    const text = this.originalTextValue;
    if (text.length > this.maxLengthValue) {
      const truncated = text.slice(0, this.maxLengthValue) + "…";
      this.buttonTarget.classList.remove("hidden");
      this.descriptionTarget.innerHTML = truncated;
    } else {
      this.descriptionTarget.innerHTML = text;
      this.buttonTarget.classList.add("hidden"); // hide if short enough
    }
  }
}
